import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Radios, Button } from 'govuk-react-jsx';
import {
  setPropertyTypeSelected,
  getPropertyTypeSelected,
} from '../../features/application/applicationJourneySlice';
// Dual language support
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';

const PropertyType = ({ location }) => {
  const isFromCheckAnswers = location?.state?.isFromCheckAnswers;
  const propertyTypeSelectedRedux = useSelector(getPropertyTypeSelected);
  const history = useHistory();
  const dispatch = useDispatch();
  const [hasError, setHasError] = useState(false);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  const handleSelection = (event) => {
    dispatch(setPropertyTypeSelected(event.target.value));
  };

  const handleBtnClick = () => {
    if (!propertyTypeSelectedRedux) {
      setHasError(true);
    } else {
      setHasError(false);
      if (isFromCheckAnswers) {
        history.push('/landlordApp/check-your-answers');
      } else {
        history.push('/landlordApp/declaration');
      }
    }
  };

  const errorMessage = copyProvider.getCopy(
    'landlordApp.PropertyType.s2',
    'Select a property type'
  );

  const pageModel = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordApp.PropertyType.s1',
          'What type of property are you applying for?'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.PropertyType.s6',
          'If you want to apply for a residential and a commercial grant for the same property, you will need to create two different applications to do this'
        )}
      </p>
      <p
        className="govuk-body govuk-hint govuk-!-margin-top-4"
        id="countries-hint"
      >
        {copyProvider.getCopy(
          'landlordApp.PropertyType.s7',
          'Select the property type you want to start an application for'
        )}
      </p>
      {/* TODO:  Update the values of propery types 
        Residential --> residential properties
        Commercial --> commercial properties
      */}
      <Radios
        onClick={(event) => handleSelection(event)}
        value={propertyTypeSelectedRedux}
        errorMessage={
          hasError && {
            children: errorMessage,
          }
        }
        idPrefix="convention"
        items={[
          {
            children: copyProvider.getCopy(
              'landlordApp.PropertyType.s3',
              'Residential'
            ),
            value: 'Residential',
          },

          {
            children: copyProvider.getCopy(
              'landlordApp.PropertyType.s4',
              'Commercial'
            ),
            value: 'Commercial',
          },
        ]}
      />
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('landlordApp.PropertyType.s5', 'Continue')}
      </Button>
    </>
  );

  return pageModel;
};
PropertyType.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      isFromCheckAnswers: PropTypes.bool,
    }),
  }),
};

PropertyType.defaultProps = {
  location: {
    state: {
      isFromCheckAnswers: false,
    },
  },
};
export default PropertyType;
